export default "__VITE_ASSET__lEMT8dnk__"